(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["darchi-gallery-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
    class DarchiLoopGallery {
      constructor(root, track, productMedia = false) {
        this.root = root;
        this.track = track;
        this.productMedia = productMedia;
        this.index = 0;
        this.pendingIndex = null;
        this.suppressClickUntil = 0;
        this.scrollFrame = 0;
        this.settleTimer = 0;
        this.previous = root.querySelector(productMedia ? 'button[name="previous"]' : '[data-photo-direction="-1"]');
        this.next = root.querySelector(productMedia ? 'button[name="next"]' : '[data-photo-direction="1"]');
        this.counter = root.querySelector(productMedia ? '.slider-counter--current' : '[data-photo-index]');
        this.total = productMedia ? root.querySelector('.slider-counter--total') : null;
        this.mediaGallery = productMedia ? root.closest('media-gallery') : null;
        if (productMedia) root.enableSliderLooping = true;
        this.refresh();
        [this.previous, this.next].forEach((button, number) => {
          button?.addEventListener('click', event => {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.go((this.pendingIndex ?? this.index) + (number ? 1 : -1));
          }, true);
        });
        track.addEventListener('scroll', () => {
          this.suppressClickUntil = performance.now() + 350;
          if (!this.scrollFrame) this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = 0;
            this.sync();
          });
          this.scheduleFinish();
        }, { passive: true });
        track.addEventListener('pointerdown', event => this.startDrag(event), { passive: true });
        track.addEventListener('pointermove', event => this.moveDrag(event), { passive: true });
        track.addEventListener('pointerup', event => this.endDrag(event), { passive: true });
        track.addEventListener('pointercancel', () => this.cancelDrag(), { passive: true });
        track.addEventListener('dragstart', event => event.preventDefault());
        track.addEventListener('click', event => {
          if (performance.now() < this.suppressClickUntil) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, true);
        track.addEventListener('keydown', event => {
          if (event.target.closest('input, select, textarea, video, model-viewer, deferred-media')) return;
          const rtl = getComputedStyle(track).direction === 'rtl';
          const direction = event.key === 'ArrowRight' ? (rtl ? -1 : 1) : event.key === 'ArrowLeft' ? (rtl ? 1 : -1) : 0;
          if (!direction && !['Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          this.go(event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : (this.pendingIndex ?? this.index) + direction);
        });
        this.resizeObserver = new ResizeObserver(() => this.go(this.index, false));
        this.resizeObserver.observe(track);
        if (productMedia) {
          this.contentObserver = new MutationObserver(() => this.refresh());
          this.contentObserver.observe(track, { childList: true });
        }
      }
      refresh() {
        this.slides = Array.from(this.track.children);
        if (this.productMedia) {
          this.root.resetPages?.();
          const active = this.slides.findIndex(slide => slide.classList.contains('is-active'));
          if (active >= 0) this.index = active;
        }
        this.index = Math.min(this.index, Math.max(0, this.slides.length - 1));
        this.go(this.index, false);
      }
      position(index) {
        return this.slides[index].offsetLeft - this.slides[0].offsetLeft;
      }
      sync() {
        if (!this.slides.length || !this.track.clientWidth) return;
        const oldIndex = this.index;
        this.index = this.slides.reduce((best, slide, index) =>
          Math.abs(this.position(index) - this.track.scrollLeft) < Math.abs(this.position(best) - this.track.scrollLeft) ? index : best, 0);
        if (this.pendingIndex === this.index && Math.abs(this.position(this.index) - this.track.scrollLeft) < 2) this.pendingIndex = null;
        if (this.counter) this.counter.textContent = this.index + 1;
        if (this.total) this.total.textContent = this.slides.length;
        [this.previous, this.next].forEach(button => { if (button) button.disabled = this.slides.length < 2; });
        if (!this.productMedia) {
          this.slides.forEach((slide, number) => { slide.tabIndex = number === this.index ? 0 : -1; });
        } else if (oldIndex !== this.index) {
          const active = this.slides[this.index];
          this.slides.forEach(slide => slide.classList.toggle('is-active', slide === active));
        }
      }
      scheduleFinish() {
        if (this.settleTimer) clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => {
          this.settleTimer = 0;
          this.sync();
          const active = this.slides[this.index];
          if (this.productMedia && active) this.mediaGallery?.playActiveMedia?.(active);
        }, 120);
      }
      go(target, animate = true) {
        const count = this.slides.length;
        if (!count || !this.track.clientWidth) return;
        const wrapped = target < 0 || target >= count;
        target = ((target % count) + count) % count;
        this.pendingIndex = target;
        this.track.scrollTo({ left: this.position(target), behavior: animate && !wrapped && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto' });
        this.sync();
        if (animate) this.scheduleFinish();
      }
      startDrag(event) {
        if (!event.isPrimary || event.pointerType !== 'mouse' || event.button !== 0 || this.slides.length < 2) return;
        if (event.target.closest('video, iframe, model-viewer, deferred-media')) return;
        this.sync();
        this.pendingIndex = null;
        this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, index: this.index, left: this.track.scrollLeft, horizontal: false };
      }
      moveDrag(event) {
        const drag = this.drag;
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.x;
        const dy = event.clientY - drag.y;
        if (!drag.horizontal && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          drag.horizontal = true;
          this.track.style.scrollSnapType = 'none';
          this.track.setPointerCapture(event.pointerId);
        }
        if (drag.horizontal) {
          this.suppressClickUntil = performance.now() + 350;
          this.track.scrollLeft = drag.left - dx;
        }
      }
      endDrag(event) {
        const drag = this.drag;
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.x;
        const dy = event.clientY - drag.y;
        this.drag = null;
        this.track.style.removeProperty('scroll-snap-type');
        if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
        if (!drag.horizontal) return;
        this.suppressClickUntil = performance.now() + 350;
        const moved = Math.abs(dx) > Math.min(40, this.track.clientWidth * .15) && Math.abs(dx) > Math.abs(dy);
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.go(drag.index + (moved ? (dx < 0 ? 1 : -1) * (rtl ? -1 : 1) : 0));
      }
      cancelDrag() {
        const drag = this.drag;
        this.drag = null;
        this.track.style.removeProperty('scroll-snap-type');
        if (drag?.horizontal) this.go(drag.index, false);
      }
      reconnect() {
        this.resizeObserver.observe(this.track);
        this.contentObserver?.observe(this.track, { childList: true });
      }
      disconnect() {
        this.resizeObserver.disconnect();
        this.contentObserver?.disconnect();
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        if (this.settleTimer) clearTimeout(this.settleTimer);
        this.scrollFrame = 0;
        this.settleTimer = 0;
      }
    }
    if (!customElements.get('darchi-card-gallery')) {
      customElements.define('darchi-card-gallery', class extends HTMLElement {
        connectedCallback() {
          if (this.galleryControls) return this.galleryControls.reconnect();
          const track = this.querySelector('.darchi-card-gallery__track');
          if (track) this.galleryControls = new DarchiLoopGallery(this, track);
        }
        disconnectedCallback() { this.galleryControls?.disconnect(); }
      });
    }
    const initializeMedia = scope => {
      const galleries = [...scope.querySelectorAll('media-gallery[data-darchi-loop-gallery]')];
      if (scope.matches?.('media-gallery[data-darchi-loop-gallery]')) galleries.unshift(scope);
      galleries.forEach(gallery => {
        const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
        const track = viewer?.querySelector('[id^="Slider-Gallery-"]');
        if (track && !viewer.darchiLoopControls) viewer.darchiLoopControls = new DarchiLoopGallery(viewer, track, true);
      });
    };
    customElements.whenDefined('media-gallery').then(() => {
      initializeMedia(document);
      new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType === 1) initializeMedia(node);
      }))).observe(document.body, { childList: true, subtree: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["darchi-order-customization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('darchi-personalization')) {
  customElements.define('darchi-personalization', class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('input', this);
      this.addEventListener('change', this);
      this.addEventListener('click', this);
    }
    disconnectedCallback() {
      this.removeEventListener('input', this);
      this.removeEventListener('change', this);
      this.removeEventListener('click', this);
      if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
    }
    handleEvent(event) {
      if (event.type === 'input' && event.target.matches('[data-custom-text]')) {
        const preview = this.querySelector('[data-text-preview]');
        preview.textContent = event.target.value;
        preview.parentElement.hidden = !event.target.value.trim();
      }
      if (event.type === 'click' && event.target.closest('[data-clear-file]')) {
        const input = this.querySelector('[data-darchi-reference-file]');
        input.value = '';
        this.updateFile(input);
      }
      if (event.type === 'change' && event.target.matches('[data-darchi-reference-file]')) this.updateFile(event.target);
    }
    updateFile(input) {
      const file = input.files[0];
      const summary = this.querySelector('.darchi-personalization__file-summary');
      const preview = this.querySelector('[data-artwork-preview]');
      if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
      this.previewUrl = null;
      preview.hidden = true;
      preview.removeAttribute('src');
      input.setCustomValidity('');
      summary.hidden = !file;
      summary.removeAttribute('data-error');
      if (!file) return;
      let error = '';
      if (file.size > 10 * 1024 * 1024) error = input.dataset.sizeError;
      else if (!/\.(jpe?g|png|webp|pdf)$/i.test(file.name)) error = input.dataset.typeError;
      this.querySelector('[data-file-status]').textContent = error || file.name;
      if (error) {
        input.setCustomValidity(error);
        summary.setAttribute('data-error', '');
      } else if (/^image\/(jpeg|png|webp)$/.test(file.type)) {
        this.previewUrl = URL.createObjectURL(file);
        preview.src = this.previewUrl;
        preview.hidden = false;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
